<div>
  <app-player-profile-statistics-filter (onFilterChanged)="filterChanged($event)"
                                        [showYearlyQuarterlyMonthly]="true"
                                        [showStartPoints]="true"
                                        [showEventKind]="false"
                                        [locked]="!isPro"/>

  <app-loading [active]="isLoading && !tableData" [center]="true"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  <div id="playerProfileStatisticTableDiv">
    @if (tableData && !errorMsg) {
      <p-table #table
               class="frontend p-datatable-sm"
               [loading]="isLoading"

               [value]="tableData"
               [selectionMode]="undefined"

               [scrollable]="true"
               [scrollHeight]="tableScrollHeight"

               groupRowsBy="header"
               rowGroupMode="subheader"
               [sortMode]="undefined"

               [stripedRows]="true" [showGridlines]="true">

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="100" class="py-4">
              {{'NO_STATISTICS' | translate}}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th [style]="'width: ' + labelColWidth + 'px;'" pFrozenColumn></th>
            @for (data of data.statisticsTable; track data) {
              <th class="text-center" [style]="'width: ' + dataColWidth + 'px;'">
                <div class="cell-nowrap">
                  {{ data.colHeader | translate }}
                </div>
              </th>
            }
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="groupheader" let-item>
          <tr pRowGroupHeader class="group-header-accent z-6">
            <td class="border-top-bottom-gray" colspan="2" pFrozenColumn>
              {{ item.header | translate }}
            </td>
            <td class="border-top-bottom-gray" colspan="100"></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td class="border-right-gray z-5" pFrozenColumn>
              <div [style]="'width: ' + labelColWidth + 'px;'" class="cell-nowrap">
                {{ item.label | translate }}
              </div>
            </td>
            @for (value of item.values; track i; let i = $index) {
              <td class="text-right">
                <div class="cell-nowrap">
                  @if (value) {
                    @if (item.trend[i] === 1) {
                      <i class="pi pi-arrow-up text-sm green pr-1"></i>
                    } @else if (item.trend[i] === 0) {
                      <i class="pi pi-arrow-left text-sm text-orange-frontend pr-1"></i>
                    } @else if (item.trend[i] === -1) {
                      <i class="pi pi-arrow-down text-sm red pr-1"></i>
                    }
                  }
                  @if (item.percentage[i] >= 0) {
                    <span>
                      ({{item.percentage[i] | number: '1.1-1'}} %)
                    </span>
                  }
                  {{ value === 0 ? '-' : value }}
                </div>
              </td>
            }
            <td></td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>

  @if (!isPro) {
    <app-player-profile-pro-feature label="PLAYER_PROFILE_FEATURE_MORE_FEATURES_PRO" headerLabel=""/>
  }
</div>
